import {useSelector} from "react-redux";
import {Navigate} from "react-router-dom";
import ConfirmationDialog from "../components/ConfirmationDialog";
import React from "react";
import {useIsOneHourPassed} from "../hooks/useIsOneHourPassed";
import {logoutIfTimePassed} from "../helpers/logoutIfTimePassed";

const AuthGuard = ({children}) => {
    const {
        openSessionDialog,
        setOpenSessionDialog,
        counterMsg,
        handleStayActive,
        handleLogout
    } = useIsOneHourPassed()

    logoutIfTimePassed({handleLogout})

    const {isLoggedIn} = useSelector((state) => state?.auth);

    return isLoggedIn ? <>
        <ConfirmationDialog
            title="Action Required"
            description={`You will be logged out in ${counterMsg} seconds.`}
            btnConfirmName={'Stay'}
            hasCancel={false}
            hasClose={false}
            open={openSessionDialog}
            onClose={(value, reason) => {
                if (reason === "backdropClick")
                    return;

                if (value) {
                    handleStayActive()
                } else {
                    handleLogout()
                }
                setOpenSessionDialog(false);
            }}
        />
        {children}
    </> : <Navigate to="/"/>;
};

export default AuthGuard;
